// use-fetch-data.js
import { useEffect, useState } from "react";
import { GET_WORKACTIVITY_TECHINICALDEPUTY } from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

interface WorkActivity {
  id: number;
  name: string;
  description: string;
  unit: string;
  workType: number;
  isApproved: Boolean;
  price: number;
}

interface WorkActivities {
  workActivities: WorkActivity[];
}

let val: WorkActivities;

const useFetchData = () => {
  const [data, setData] = useState(val);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await api
          .get(GET_WORKACTIVITY_TECHINICALDEPUTY, null)
          .then((response) => {
            setData(JSON.parse(JSON.stringify(response)));
            setLoading(false);
          });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return {
    data,
    loading,
  };
};

export default useFetchData;
